import React from 'react';
import OrderExchangeManagementListSearchBox from '../OrderExchangeManagementListSearchBox';
import OrderExchangeManagementList from '../OrderExchangeManagementList';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
  ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../../store/modules/order/models';
import { SEARCH_PERIOD_BUTTON_ALL_TYPE } from '../../../../../../constants/service/common/utilConstants';

const OrderExchangeManagementListWrap = (props) => {
  const {
    orderExchangeManagement,
    setData,
    getList,
    getAllListExcelDownload,
    getSelectedListExcelDownload,
    onCheckOrderItem,
    completeCollectionOrderExchange,
    failCollectionRejectOrderExchange,
    editReasonOrderExchange,
    editDeliveryInfo,
    completeOrderExchange,
    rejectOrderExchange,
    changeExchangeToReturn,
    getOrderExchangeAttachment,
  } = props;
  const { orderExchangeManagementSelectedList, orderExchangeManagementList } = orderExchangeManagement;
  const {
    exchangeRequestDate,
    orderExchangeStatusList,
    exchangeAcceptManagerList,
    orderItemDetailSearch,
    exchangeReasonTypeList,
    productType,
    store,
  } = orderExchangeManagementList.searchData;

  return (
    <div className="order-exchange-management-list-wrap">
      <OrderExchangeManagementListSearchBox
        setData={(data) =>
          setData({
            path: ['orderExchangeManagement', 'orderExchangeManagementList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderExchangeManagementList.searchData}
        onSearch={() =>
          getList({
            searchOption: {
              /**
               *  교환 요청 일시
               */
              exchangeRequestDate:
                exchangeRequestDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE
                  ? exchangeRequestDate.period
                  : null,
              /**
               *  상품 주문 교환 상태 리스트
               */
              orderExchangeStatusList,
              /**
               *  교환 접수자 리스트
               */
              exchangeAcceptManagerList,
              /**
               *  상세 검색
               */
              orderItemDetailSearch,
              /**
               *  교환 사유 리스트
               */
              exchangeReasonTypeList,
              /**
               *  상품 타입
               */
              productType,
              /**
               *  판매처
               */
              store,
            },
            pagination: _LIST_PAGINATION_MODEL,
          })
        }
        onClear={() => {
          getList({
            searchOption: ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
            pagination: _LIST_PAGINATION_MODEL,
          });
          setData({
            path: ['orderExchangeManagement', 'orderExchangeManagementList', 'searchData'],
            value: ORDER_EXCHANGE_MANAGEMENT_LIST_SEARCH_DATA_MODEL,
          });
        }}
      />

      <OrderExchangeManagementList
        orderExchangeManagementList={orderExchangeManagementList}
        orderExchangeManagementSelectedList={orderExchangeManagementSelectedList}
        getList={getList}
        getAllListExcelDownload={getAllListExcelDownload}
        getSelectedListExcelDownload={getSelectedListExcelDownload}
        onCheckOrderItem={onCheckOrderItem}
        completeCollectionOrderExchange={completeCollectionOrderExchange}
        failCollectionRejectOrderExchange={failCollectionRejectOrderExchange}
        editReasonOrderExchange={editReasonOrderExchange}
        editDeliveryInfo={editDeliveryInfo}
        completeOrderExchange={completeOrderExchange}
        rejectOrderExchange={rejectOrderExchange}
        changeExchangeToReturn={changeExchangeToReturn}
        getOrderExchangeAttachment={getOrderExchangeAttachment}
      />
    </div>
  );
};

export default OrderExchangeManagementListWrap;
